import { Camelized } from 'humps';
import { DefaultCharge, DefaultChargeResource } from 'services/resources';

export const START_LOADING = 'app/services/FleetSettings/START_LOADING';

export const GET_FLEET_SETTINGS_SUCCESS = 'app/services/FleetSettings/GET_FLEET_SETTINGS_SUCCESS';
export const GET_FLEET_SETTINGS_FAIL = 'app/services/FleetSettings/GET_FLEET_SETTINGS_FAIL';
export const UPDATE_FLEET_SETTINGS_SUCCESS = 'app/services/FleetSettings/UPDATE_FLEET_SETTINGS_SUCCESS';
export const UPDATE_FLEET_SETTINGS_FAIL = 'app/services/FleetSettings/UPDATE_FLEET_SETTINGS_FAIL';
export const GET_FLEET_SETTINGS_ALERTS_SUCCESS = 'app/services/FleetSettings/GET_FLEET_SETTINGS_ALERTS_SUCCESS';
export const GET_FLEET_SETTINGS_ALERTS_FAIL = 'app/services/FleetSettings/GET_FLEET_SETTINGS_ALERTS_FAIL';
export const UPDATE_FLEET_SETTINGS_ALERTS_SUCCESS = 'app/services/FleetSettings/UPDATE_FLEET_SETTINGS_ALERTS_SUCCESS';
export const UPDATE_FLEET_SETTINGS_ALERTS_FAIL = 'app/services/FleetSettings/UPDATE_FLEET_SETTINGS_ALERTS_FAIL';
export const GET_TERMS_AND_CONDITIONS_SUCCESS = 'app/services/FleetSettings/GET_TERMS_AND_CONDITIONS_SUCCESS';
export const GET_TERMS_AND_CONDITIONS_FAIL = 'app/services/FleetSettings/GET_TERMS_AND_CONDITIONS_FAIL';
export const CREATE_TERMS_AND_CONDITIONS_SUCCESS = 'app/services/FleetSettings/CREATE_TERMS_AND_CONDITIONS_SUCCESS';
export const CREATE_TERMS_AND_CONDITIONS_FAIL = 'app/services/FleetSettings/CREATE_TERMS_AND_CONDITIONS_FAIL';
export const UPDATE_TERMS_AND_CONDITIONS_SUCCESS = 'app/services/FleetSettings/UPDATE_TERMS_AND_CONDITIONS_SUCCESS';
export const UPDATE_TERMS_AND_CONDITIONS_FAIL = 'app/services/FleetSettings/UPDATE_TERMS_AND_CONDITIONS_FAIL';

export const GET_CHARGES_SUCCESS = 'app/services/FleetSettings/GET_CHARGES_SUCCESS';
export const GET_CHARGES_FAIL = 'app/services/FleetSettings/GET_CHARGES_FAIL';
export const GET_CHARGE_SUCCESS = 'app/services/FleetSettings/GET_CHARGE_SUCCESS';
export const GET_CHARGE_FAIL = 'app/services/FleetSettings/GET_CHARGE_FAIL';
export const GET_DEFAULT_CHARGES_SUCCESS = 'app/services/FleetSettings/GET_DEFAULT_CHARGES_SUCCESS';
export const GET_DEFAULT_CHARGES_FAIL = 'app/services/FleetSettings/GET_DEFAULT_CHARGES_FAIL';
export const CLEAR_CHARGES = 'app/services/FleetSettings/CLEAR_CHARGES';
export const ADD_CHARGE_SUCCESS = 'app/services/FleetSettings/ADD_CHARGE_SUCCESS';
export const ADD_CHARGE_FAIL = 'app/services/FleetSettings/ADD_CHARGE_FAIL';

export const EDIT_CHARGE_SUCCESS = 'app/services/FleetSettings/EDIT_CHARGE_SUCCESS';
export const EDIT_CHARGE_FAIL = 'app/services/FleetSettings/EDIT_CHARGE_FAIL';

export const DELETE_CHARGE_SUCCESS = 'app/services/FleetSettings/DELETE_CHARGE_SUCCESS';
export const DELETE_CHARGE_FAIL = 'app/services/FleetSettings/DELETE_CHARGE_FAIL';

export const GET_TAXES_SUCCESS = 'app/services/FleetSettings/GET_TAXES_SUCCESS';
export const GET_TAXES_FAIL = 'app/services/FleetSettings/GET_TAXES_FAIL';
export const ADD_TAX_SUCCESS = 'app/services/FleetSettings/ADD_TAX_SUCCESS';
export const ADD_TAX_FAIL = 'app/services/FleetSettings/ADD_TAX_FAIL';
export const UPDATE_TAX_SUCCESS = 'app/services/FleetSettings/UPDATE_TAX_SUCCESS';
export const UPDATE_TAX_FAIL = 'app/services/FleetSettings/UPDATE_TAX_FAIL';
export const DELETE_TAX_SUCCESS = 'app/services/FleetSettings/DELETE_TAX_SUCCESS';
export const DELETE_TAX_FAIL = 'app/services/FleetSettings/DELETE_TAX_FAIL';

export const GET_DEALERSHIP_SETTINGS_SUCCESS = 'app/services/Settings/GET_FLEET_SETTINGS_SUCCESS';
export const GET_DEALERSHIP_SETTINGS_FAIL = 'app/services/Settings/GET_FLEET_SETTINGS_FAIL';
export const UPDATE_DEALERSHIP_SETTINGS_SUCCESS = 'app/services/Settings/UPDATE_FLEET_SETTINGS_SUCCESS';
export const UPDATE_DEALERSHIP_SETTINGS_FAIL = 'app/services/Settings/UPDATE_FLEET_SETTINGS_FAIL';

export const GET_DEVICES_SUCCESS = 'app/services/FleetSettings/GET_DEVICES_SUCCESS';
export const GET_DEVICES_FAIL = 'app/services/FleetSettings/GET_DEVICES_FAIL';
export const DISCONNECT_DEVICE_SUCCESS = 'app/services/FleetSettings/DISCONNECT_DEVICE_SUCCESS';
export const DISCONNECT_DEVICE_FAIL = 'app/services/FleetSettings/DISCONNECT_DEVICE_FAIL';

export const FORCE_VIN_SUCCESS = 'app/services/FleetSettings/FORCE_VIN_SUCCESS';
export const FORCE_VIN_FAIL = 'app/services/FleetSettings/FORCE_VIN_FAIL';

export const startLoading = () => ({
  type: START_LOADING,
});

export const receivedGetFleetSettingsSuccess = (settings) => ({
  type: GET_FLEET_SETTINGS_SUCCESS,
  payload: { settings },
});

export const receivedGetFleetSettingsFail = (errors) => ({
  type: GET_FLEET_SETTINGS_FAIL,
  payload: { errors },
});

export const receivedUpdateFleetSettingsSuccess = (settings) => ({
  type: UPDATE_FLEET_SETTINGS_SUCCESS,
  payload: { settings },
});

export const receivedUpdateFleetSettingsFail = (errors) => ({
  type: UPDATE_FLEET_SETTINGS_FAIL,
  payload: { errors },
});

export const receivedFleetSettingsAlertsSuccess = (alerts) => ({
  type: GET_FLEET_SETTINGS_ALERTS_SUCCESS,
  payload: { alerts },
});

export const receivedFleetSettingsAlertsFail = (errors) => ({
  type: GET_FLEET_SETTINGS_ALERTS_FAIL,
  payload: { errors },
});

export const receivedUpdatedFleetSettingsAlertsSuccess = (alerts) => ({
  type: UPDATE_FLEET_SETTINGS_ALERTS_SUCCESS,
  payload: { alerts },
});

export const receivedUpdatedFleetSettingsAlertsFail = (errors) => ({
  type: UPDATE_FLEET_SETTINGS_ALERTS_FAIL,
  payload: { errors },
});

export const receivedTermsAndConditionsSuccess = (termsAndConditions) => ({
  type: GET_TERMS_AND_CONDITIONS_SUCCESS,
  payload: { termsAndConditions },
});

export const receivedTermsAndConditionsFail = (errors) => ({
  type: GET_TERMS_AND_CONDITIONS_FAIL,
  payload: { errors },
});

export const receivedCreatedTermsAndConditionsSuccess = (termsAndConditions) => ({
  type: CREATE_TERMS_AND_CONDITIONS_SUCCESS,
  payload: { termsAndConditions },
});

export const receivedCreatedTermsAndConditionsFail = (errors) => ({
  type: CREATE_TERMS_AND_CONDITIONS_FAIL,
  payload: { errors },
});

export const receivedUpdatedTermsAndConditionsSuccess = (termsAndConditions) => ({
  type: UPDATE_TERMS_AND_CONDITIONS_SUCCESS,
  payload: { termsAndConditions },
});

export const receivedUpdatedTermsAndConditionsFail = (errors) => ({
  type: UPDATE_TERMS_AND_CONDITIONS_FAIL,
  payload: { errors },
});

//////////////////////////////////////////////

// CHARGES

//////////////////////////////////////////////

export const receivedChargesSuccess = (data: Camelized<DefaultChargeResource[]>) => ({
  type: GET_CHARGES_SUCCESS,
  payload: { data },
});

export const receivedChargeSuccess = (charge: DefaultCharge) => ({
  type: GET_CHARGE_SUCCESS,
  payload: { charge },
});

export const recievedChargeFail = (errors) => ({
  type: GET_CHARGE_FAIL,
  payload: { errors },
});

export const receivedChargesFail = (errors) => ({
  type: GET_CHARGES_FAIL,
  payload: { errors },
});

export const receivedAddChargeSuccess = (charge: DefaultCharge) => ({
  type: ADD_CHARGE_SUCCESS,
  payload: { charge },
});

export const receivedAddChargeFail = (errors) => ({
  type: ADD_CHARGE_FAIL,
  payload: { errors },
});

export const receivedEditChargeSuccess = (id: number, charge: DefaultCharge) => ({
  type: EDIT_CHARGE_SUCCESS,
  payload: { id, charge },
});

export const receivedEditChargeFail = (errors) => ({
  type: EDIT_CHARGE_FAIL,
  payload: { errors },
});

export const receivedDeleteChargeSuccess = (id: number) => ({
  type: DELETE_CHARGE_SUCCESS,
  payload: { id },
});

export const receivedClearCharges = () => ({
  type: CLEAR_CHARGES,
});

export const receivedDeleteChargeFail = (errors) => ({
  type: DELETE_CHARGE_FAIL,
  payload: { errors },
});

export const receivedDefaultChargesSuccess = (defaultCharges: Camelized<DefaultChargeResource[]>) => ({
  type: GET_DEFAULT_CHARGES_SUCCESS,
  payload: { defaultCharges },
});

export const receivedDefaultChargesFail = (errors) => ({
  type: GET_DEFAULT_CHARGES_FAIL,
  payload: { errors },
});

/////////////////////////////////////////////

// TAXES

//////////////////////////////////////////////

export const receivedTaxesSuccess = (data) => ({
  type: GET_TAXES_SUCCESS,
  payload: { data },
});

export const receivedTaxesFail = (errors) => ({
  type: GET_TAXES_FAIL,
  payload: { errors },
});

export const receivedAddTaxSuccess = (tax) => ({
  type: ADD_TAX_SUCCESS,
  payload: { tax },
});

export const receivedAddTaxFail = (errors) => ({
  type: ADD_TAX_FAIL,
  payload: { errors },
});

export const receivedUpdateTaxSuccess = (tax) => ({
  type: UPDATE_TAX_SUCCESS,
  payload: { tax },
});

export const receivedUpdateTaxFail = (errors) => ({
  type: UPDATE_TAX_FAIL,
  payload: { errors },
});

export const receivedDeleteTaxSuccess = (id) => ({
  type: DELETE_TAX_SUCCESS,
  payload: { id },
});

export const receivedDeleteTaxFail = (errors) => ({
  type: DELETE_TAX_FAIL,
  payload: { errors },
});

/////////////////////////////////////////////

// DEVICES

//////////////////////////////////////////////

export const receivedDevicesSuccess = (data) => ({
  type: GET_DEVICES_SUCCESS,
  payload: { data },
});

export const receivedDevicesFail = (errors) => ({
  type: GET_DEVICES_FAIL,
  payload: { errors },
});

export const receivedDisconnectDeviceSuccess = (data) => ({
  type: DISCONNECT_DEVICE_SUCCESS,
  payload: { data },
});

export const receivedDisconnectDeviceFail = (errors) => ({
  type: DISCONNECT_DEVICE_FAIL,
  payload: { errors },
});

export const receivedForceVinSuccess = (data) => ({
  type: FORCE_VIN_SUCCESS,
  payload: { data },
});

export const receivedForceVinFail = (errors) => ({
  type: FORCE_VIN_FAIL,
  payload: { errors },
});
